import { render } from "./Array.vue?vue&type=template&id=18145dc6&lang=pug"
import script from "./Array.vue?vue&type=script&lang=ts"
export * from "./Array.vue?vue&type=script&lang=ts"
script.render = render

export default script